import styles from './TrendsCount.module.scss'
import moment from 'moment'

const GraphCount = ({ data, filter }) => {
  return (
  <td style={{ width:(filter===1? '10.5%':(filter===2?'100px':'160px')) }}>{data<=-1?0:data}</td>

  )
}
const getTrendsCount = ({ data,filter }) => {
  if (data.series.length!==0&&data.series[0].data !== null && data.series[0].data !== undefined && filter!==undefined) {
    return(
      <div className={styles.maindivFormat} style={{ width:(filter===1? '100%':(filter===2?'200%':'420%')),paddingBottom:'10px' }}>
      <table >
        <thead>
          <tr>
            <th style={{width:'80px'}}></th>
            {data.series[0].data.map((data_val) => {
              return <th style={{ width:(filter===1? '10.5%':(filter===2?'100px':'160px')), }}>{moment(data_val[0]).format('MMM DD')}</th>}
              )}
          </tr>
        </thead>
        <tbody>
        {data.series.map((data_series, index) => {
          return <tr>
                <td style={{width:'80px',wordWrap:'break-word'}}>{data_series.name}</td>
                {data_series.data.map((data_val, index) => {
                  return <GraphCount key={index} data={data_val[1]} isMale={true} />
                })}
              </tr>
        })}
          
         
        </tbody>
      </table>
      </div>
    )
  } else {
    return <div style={{padding:'10px 20px'}}>Data Not Available</div>
  }
}

export default getTrendsCount
